@if (menus.length > 0) {
  <lib-sidebar-menu [menus]="menus" />
}
<div class="w-ful absolute bottom-0 z-[1200] ml-2">
  <shared-version />
</div>
